import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '../default';

import { getStepStatuses } from './actions';
import { StepStatusesState } from './types';

export default createReducer(initialState as StepStatusesState, builder => {
  builder
    .addCase(getStepStatuses.pending, state => {
      state.pending = true;
    })
    .addCase(getStepStatuses.fulfilled, (state, { payload }) => {
      state.pending = false;
      state.fullfilled = true;
      state.data = payload;
    })
    .addCase(getStepStatuses.rejected, state => {
      state.pending = false;
      state.error = true;
    });
});
